import { call, put, takeLatest, fork, all } from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as Func from "../helpers/functions";
import { parseListRequestParamsCameo } from '../utils/commonUtils';
import i18n from '../constants/initLng';
import { PATHS } from '../constants/Define';
import * as GroupCategoryActions from '../actions/groupCategoryAction';
import * as GroupCategoryService from './../services/groupCategoryService';
import history from './../helpers/history';


function* getGroupCategories() {
    yield takeLatest(Types.GROUP_CATEGORY_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseListRequestParamsCameo(action.params || {});
        const result = yield call(GroupCategoryService.getGroupCategories, params);
        yield put(GroupCategoryActions.setGroupCategories(result));
    }, errorHandleGroupCategory(Types.GROUP_CATEGORY_FAIL)))
}

function* getAllGroupCategories() {
    yield takeLatest(Types.GROUP_CATEGORY_LIST_ALL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(GroupCategoryService.getAllGroupCategories, action.params);
        yield put(GroupCategoryActions.setAllGroupCategories(result));
    }, errorHandleGroupCategory(Types.GROUP_CATEGORY_FAIL)))
}

function* getGroupCategoryDetail() {
    yield takeLatest(Types.GROUP_CATEGORY_GET_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(GroupCategoryService.getGroupCategoryDetail, action.id, action.language);
        yield put(GroupCategoryActions.setGroupCategoryDetail(result, action.language));
    }, errorHandleGroupCategory(Types.GROUP_CATEGORY_FAIL)))
}

function* createGroupCategory() {
    yield takeLatest(Types.GROUP_CATEGORY_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(GroupCategoryService.createGroupCategory, action.groupCategory);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'), action.groupCategory.name);
        history.push(PATHS.GROUP_CATEGORY.LIST.path); history.go();
    }, errorHandleGroupCategory(Types.GROUP_CATEGORY_FAIL)))
}

function* updateGroupCategory() {
    yield takeLatest(Types.GROUP_CATEGORY_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(GroupCategoryService.updateGroupCategory, action.groupCategory);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), action.groupCategory.name);
        yield put({ type: Types.GROUP_CATEGORY_UPDATE_SUCCESS });
    }, errorHandleGroupCategory(Types.GROUP_CATEGORY_FAIL)))
}

function* deleteGroupCategory() {
    yield takeLatest(Types.GROUP_CATEGORY_DELETE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(GroupCategoryService.deleteGroupCategory, action.groupCategory.id);
        Func.sagaSuccessMessage(action, i18n.t('notification.removeSuccess'));
        yield put({ type: Types.GROUP_CATEGORY_LIST_ACTION, params: action.refreshParams })
    }, errorHandleGroupCategory(Types.GROUP_CATEGORY_FAIL)))
}

// function* getGroupCategoryTranslate() {
//     yield takeLatest(Types.GROUP_CATEGORY_GET_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
//         const result = yield call(GroupCategoryService.getGroupCategoryDetail, action.id, action.language);
//         yield put(GroupCategoryActions.setGroupCategoryTranslate(result, action.language));
//     }, errorHandleGroupCategory(Types.GROUP_CATEGORY_FAIL)))
// }

function* createGroupCategoryTranslate() {
    yield takeLatest(Types.GROUP_CATEGORY_CREATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(GroupCategoryService.createGroupCategoryTranslate, action.groupCategory);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'), action.groupCategory.translate.languageName);
        yield put({ type: Types.GROUP_CATEGORY_CREATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.GROUP_CATEGORY_GET_DETAIL_ACTION, id: action.groupCategory.id });
    }, errorHandleGroupCategory(Types.GROUP_CATEGORY_FAIL)))
}

function* updateGroupCategoryTranslate() {
    yield takeLatest(Types.GROUP_CATEGORY_UPDATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(GroupCategoryService.updateGroupCategoryTranslate, action.groupCategory);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), action.groupCategory.translate.languageName);
        yield put({ type: Types.GROUP_CATEGORY_UPDATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.GROUP_CATEGORY_GET_DETAIL_ACTION, id: action.groupCategory.id });
    }, errorHandleGroupCategory(Types.GROUP_CATEGORY_FAIL)))
}

function* deleteGroupCategoryTranslate() {
    yield takeLatest(Types.GROUP_CATEGORY_DELETE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(GroupCategoryService.deleteGroupCategoryTranslate, action.groupCategory.translate.id);
        Func.sagaSuccessMessage(action, i18n.t('notification.removeSuccess'), action.groupCategory.translate.languageName);
        yield put({ type: Types.GROUP_CATEGORY_DELETE_TRANSLATE_SUCCESS });
        yield put({ type: Types.GROUP_CATEGORY_GET_DETAIL_ACTION, id: action.refreshParams.id });
    }, errorHandleGroupCategory(Types.GROUP_CATEGORY_FAIL)))
}

function errorHandleGroupCategory(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'groupCategory');
}

export function* groupCategorySaga() {
    yield all([
        fork(getGroupCategories),
        fork(getAllGroupCategories),
        fork(getGroupCategoryDetail),
        fork(createGroupCategory),
        fork(updateGroupCategory),
        fork(deleteGroupCategory),

        //Translate
        // fork(getGroupCategoryTranslate),
        fork(createGroupCategoryTranslate),
        fork(updateGroupCategoryTranslate),
        fork(deleteGroupCategoryTranslate),
    ])
}
